<div class="container mx-auto px-4 py-2 md:pt-6 text-gray-800">
  <h1 class="text-2xl md:text-4xl font-semibold ml-10 mb-4 md:block hidden">
    Контакти с na2kolela.bg
  </h1>
  <hr class="border-t-4 border-green-500 mb-8 md:mb-12 md:block hidden" />
  <div
    class="flex flex-col md:flex-row md:space-x-8 md:items-start space-y-4 md:space-y-0"
  >
    <div class="space-y-5 md:space-y-6 md:text-xl md:w-4/5">
      <h2 class="text-xl md:text-[26px] font-medium">
        Публикуване на обяви и поддръжка на акаунт
      </h2>

      <div class="space-y-1 md:space-y-2">
        <p>
          <span class="font-bold mr-2">Телефон:</span>
          <span>0884136687</span>
        </p>
        <p>
          <span class="font-bold mr-2">Вайбър:</span>
          <span>0884136687</span>
        </p>
        <p>
          <span class="font-bold mr-2">Имейл:</span>
          <span>na2kolela&#64;gmail.com</span>
        </p>
      </div>

      <div class="font-semibold">
        <h3 class="mb-1">Работно време</h3>
        <p>от 9:00 до 17:00 /без събота и неделя/</p>
      </div>

      <div>
        <h3 class="mb-1">Трейдит&nbsp;24&nbsp;ООД</h3>
        <p>ЕИК&nbsp;207871613</p>
      </div>
    </div>

    <div
      class="flex justify-center md:justify-end items-center pt-8 md:pt-40 md:w-2/5"
    >
      <img
        src="assets/contacts-icon.svg"
        alt="Contact Icons"
        class="object-contain md:w-60 md:h-60 w-48 h-48 mt-40"
      />
    </div>
  </div>
</div>
